import { render, staticRenderFns } from "./CompanyArtists.vue?vue&type=template&id=09d1b445&scoped=true"
import script from "./CompanyArtists.vue?vue&type=script&lang=ts"
export * from "./CompanyArtists.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d1b445",
  null
  
)

export default component.exports